{
  "events-logger": {
    "event-logs": "Événements",
    "download": "Télécharger les événements",
    "copy-to-clipboard": "Copier dans le presse-papiers",
    "expand": "Agrandir",
    "minimize": "Réduire",
    "no-events-logged-yet": "Aucun événement enregistré"
  },
  "header": {
    "session": "Session",
    "connected-as": "Connecté en tant que",
    "logout-from-call-center": "Déconnexion",
    "going-online": "Connexion en cours...",
    "going-offline": "Déconnexion en cours...",
    "went-online": "Vous êtes en ligne",
    "went-offline": "Vous êtes hors ligne",
    "go-online": "Passer en ligne",
    "go-offline": "Passer hors ligne",
    "handle-status": "Session",
    "server-status": "Serveur",
    "network-status": "Réseau",
    "extension-number": "# Ext.",
    "connecting-to-sip": "Connexion au serveur SIP...",
    "offline": "Hors ligne",
    "online": "En ligne"
  },
  "session": {
    "loading": "Chargement...",
    "authenticating": "Authentification...",
    "loading-user-info": "Chargement des informations utilisateur...",
    "connecting-to-sip": "Connexion au serveur SIP...",
    "offline": "Vous êtes <1>hors ligne</1>. Les appels ne seront pas transférés vers votre extension.",
    "online": "Vous êtes <1>en ligne</1>. Les appels entrants apparaîtront ici."
  },
  "new-call": {
    "call-extension": "Appeler une extension",
    "type-extension": "Tapez l'extension à appeler ou utilisez les boutons",
    "calling-extension": "Appel au {{extension}}",
    "calling": "Appel en cours...",
    "hang-up": "Raccrocher",
    "type-extension-button": "Tapez l'extension",
    "call-button": "Appeler {{extension}}"
  },
  "intercom": {
    "access-controls": {
      "title": "Contrôles d'accès",
      "description": "Gérer l'accès aux barrières et les contrôles de stationnement",
      "shared-dialog": {
        "cost-field": "Coût (optionnel)",
        "cost-field-placeholder": "Entrez le coût",
        "reason-field": "Raison",
        "reason-field-placeholder": "Entrez la raison de cette action",
        "cancel": "Annuler",
        "submit": "Soumettre",
        "gate": "Barrière : {{gateName}}"
      },
      "open-locked-gate": {
        "title": "Maintenir la barrière ouverte",
        "description": "Ouvre la barrière et la garde ouverte jusqu'à ce que quelqu'un appuie sur Fermer.",
        "confirm-before-submit": "ATTENTION : Cette action va laisser {{gateName}} ouverte jusqu'à ce que quelqu'un appuie sur Fermer.",
        "submitting": "Maintien de la barrière ouverte en cours...",
        "success": "La barrière est maintenue ouverte",
        "error": "Échec du maintien de la barrière ouverte",
        "button": "Maintenir la barrière ouverte"
      },
      "open-gate": {
        "title": "Ouvrir la barrière",
        "description": "Ouvrir la barrière pour le passage d'un véhicule",
        "submitting": "Ouverture de la barrière en cours...",
        "success": "Barrière ouverte avec succès",
        "error": "Échec de l'ouverture de la barrière",
        "button": "Ouvrir"
      },
      "close-gate": {
        "title": "Fermer la barrière",
        "description": "Libère tout maintien, puis ferme la barrière.",
        "submitting": "Fermeture de la barrière en cours...",
        "success": "Barrière fermée avec succès",
        "error": "Échec de la fermeture de la barrière",
        "button": "Fermer la barrière"
      },
      "send-lost-ticket": {
        "title": "Envoyer un billet perdu",
        "description": "Envoyer un billet perdu pour paiement au terminal",
        "submitting": "Envoi du billet perdu en cours...",
        "success": "Billet perdu envoyé avec succès",
        "error": "Échec de l'envoi du billet perdu",
        "button": "Envoyer"
      },
      "activate-loop": {
        "title": "Activer la boucle",
        "description": "Activer la boucle de détection de véhicule",
        "submitting": "Activation de la boucle en cours...",
        "success": "Boucle activée avec succès",
        "error": "Échec de l'activation de la boucle",
        "button": "Activer"
      },
      "gate-status": {
        "acts-on-label": "Ces commandes agissent sur :",
        "acts-on": "Ces commandes agissent sur : {{gateName}}",
        "loading": "Chargement de l'état de la barrière...",
        "unavailable": "État indisponible",
        "barrier-up": "Barrière levée",
        "barrier-down": "Barrière baissée",
        "barrier-up-for": "Levée depuis au moins {{minutes}} min",
        "shared-device": "Partagé avec {{gateName}} : cette lecture peut concerner l'une ou l'autre barrière.",
        "vehicle-present": "Véhicule à la borne",
        "vehicle-absent": "Aucun véhicule à la borne",
        "terminal-connected": "Terminal connecté",
        "terminal-disconnected": "Terminal déconnecté",
        "terminal-disconnected-warning": "Les commandes pourraient ne pas atteindre la barrière.",
        "held": "Maintenue ouverte",
        "held-since": "Maintenue ouverte depuis {{time}}",
        "held-reason": "Raison : {{reason}}",
        "printer": {
          "inError": "Erreur d'imprimante",
          "paperJam": "Imprimante : bourrage papier",
          "paperMissing": "Imprimante : plus de papier",
          "coverOpened": "Imprimante : capot ouvert",
          "paperNearEnd": "Imprimante : papier presque épuisé"
        }
      }
    },
    "camera-feed": {
      "title": "Caméra",
      "description": "Caméra de l'intercom en direct",
      "no-camera-available": "Aucune caméra disponible",
      "sip-camera-has-no-video-tracks": "Le signal vidéo n'est pas disponible lors de la mise en attente de l'appel.",
      "sip-camera-disconnection-warning": "Le signal vidéo sera interrompu lors de la mise en attente de l'appel. Lors du retour de l'appel, le signal vidéo sera restauré.",
      "button": "Caméra"
    },
    "procedures": {
      "intercom": {
        "title": "Procédures d'intercom",
        "description": "Procédures d'intercom",
        "no-procedures-available": "Aucune procédure d'intercom disponible",
        "button": "Procédures d'intercom"
      },
      "parking": {
        "title": "Procédures de stationnement",
        "description": "Procédures de stationnement",
        "no-procedures-available": "Aucune procédure de stationnement disponible",
        "button": "Procédures de stationnement"
      }
    },
    "contacts": {
      "title": "Contacts d'urgence",
      "description": "Informations de contact pour les urgences",
      "no-contacts-available": "Aucun contact d'urgence disponible",
      "button": "Contacts d'urgence"
    }
  },
  "announcement": {
    "title": "Notes de version",
    "got-it": "Compris"
  },
  "call-controls": {
    "answer": "Répondre",
    "decline": "Refuser",
    "resume": "Reprendre",
    "hold": "Mettre en attente",
    "hang-up": "Raccrocher",
    "keypad": "Clavier",
    "mute-input": "Couper le microphone",
    "unmute-input": "Réactiver le microphone",
    "mute-output": "Couper le haut-parleur",
    "unmute-output": "Réactiver le haut-parleur"
  },
  "devices": {
    "call-input": "Appareil audio d'entrée",
    "call-output": "Appareil audio de sortie",
    "notification-output": "Appareil audio de notifications"
  },
  "sidebar": {
    "history": "Historique des appels",
    "unknown": "Inconnu",
    "from": "de",
    "to": "vers",
    "no-entries-found": "Aucun élément trouvé",
    "no-calls-found": "Aucun appel trouvé",
    "load-more": "Charger plus",
    "loading-more": "Chargement..."
  },
  "history": {
    "call-back": "Rappeler",
    "call-back-to-reactivate-video-stream": "Rappeler va restaurer le flux vidéo."
  }
}